import { useNavigate } from 'react-router-dom'
import { Box, Typography, Button, Collapse } from '@mui/material'
import { usePushNotifications } from '../contexts/PushNotificationContext'

const colourToSeverity: Record<string, { bg: string; border: string; text: string }> = {
  info: { bg: 'info.dark', border: 'info.main', text: 'info.contrastText' },
  warning: { bg: 'warning.dark', border: 'warning.main', text: 'warning.contrastText' },
  error: { bg: 'error.dark', border: 'error.main', text: 'error.contrastText' },
}

function getStyles(colour: string) {
  // Treat empty or legacy 'default' as info
  const c = colour === 'default' || !colour ? 'info' : colour
  return colourToSeverity[c] || colourToSeverity.info
}

export default function PushNotificationBanner() {
  const navigate = useNavigate()
  const { notifications, acknowledge } = usePushNotifications()
  const current = notifications[0] ?? null

  if (!current) return null

  const styles = getStyles(current.colour)

  return (
    <Collapse in>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: styles.border,
          bgcolor: styles.bg,
          color: styles.text,
          px: 2,
          py: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={600}>
            {current.title}
          </Typography>
          {current.description && (
            <Typography variant="body2" sx={{ opacity: 0.95 }}>
              {current.description}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
          {current.link && (
            <Button
              size="small"
              variant="outlined"
              color="inherit"
              onClick={() => {
                acknowledge(current.id)
                navigate(current.link!)
              }}
              sx={{ borderColor: 'currentColor' }}
            >
              {current.link_label || 'Go to Billing'}
            </Button>
          )}
          <Button
            size="small"
            variant="outlined"
            color="inherit"
            onClick={() => acknowledge(current.id)}
            sx={{ borderColor: 'currentColor' }}
          >
            Acknowledge
          </Button>
        </Box>
      </Box>
    </Collapse>
  )
}
